module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image3-c0087d3ab934d29680b9af66b0ae88cc.png";